module.exports = __webpack_public_path__ + "static/app-shot-1-4-50ed9d85f63166f61ac52189256452d3.jpg";